import foto1 from '../../assets/images/dest1.png';
import foto2 from '../../assets/images/dest2.png';
import foto3 from '../../assets/images/dest3.png';


export const destacadosData = [
    {
        nombre: 'Durómetro',
        image: foto1,
        button: 'Ver más',
        id:'durometro'
    },
    {
        nombre: 'Texturometro',
        image: foto2,
        button: 'Ver más',
        id:'texturometro'
    },
    {
        nombre: 'Durómetro capsulas blandas',
        image: foto3,
        button: 'Ver más',
        id:'durometro-capsulas-blandas'

    },
]